export default __webpack_public_path__ + "static/media/title_final_1280_512.e747965a.png";